(function () {
	'use strict';

	angular.module('mx.components').directive('mxBindHtmlCompile', mxBindHtmlCompile);

	mxBindHtmlCompile.$inject = ['$compile'];

	function mxBindHtmlCompile($compile) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				scope.$watch(
					function () {
						return scope.$eval(attrs.mxBindHtmlCompile);
					},
					function (value) {
						element.html(value);
						$compile(element.contents())(scope);
					}
				);
			},
		};
	}
})();
